import classNames from 'classnames';
import React, { memo } from 'react';

import styles from './BuildingIcon.module.scss';

import type { BUILDINGS } from '~/Actions/ActionSupply';
import type { Nullable } from '~/types/generics';

type IProps = {
  className?: string;
  buildingId: Nullable<BUILDINGS>;
};

const BuildingIcon: React.FC<IProps> = ({ className, buildingId }) => {
  if (!buildingId) {
    return null;
  }

  return <span className={classNames(styles[`${buildingId}Icon`], className)} />;
};

export default memo(BuildingIcon);
